<template>
  <search-block
    :placeholder="placeholder"
    :options="getOptions"
    :value="formattedValue"
    :multiple="!!schema.multiple"
    :loading="searchLoading"
    collapsible
    @input="setInput"
    @updateSearch="updateSearch"
  />
</template>

<script>
import SearchBlock from '@/components/basic/search-block/SearchBlock';
import rules from '@/lib/validationRules';

export default {
  name: 'ReportSearchBlock',
  components: {
    SearchBlock,
  },
  props: {
    schema: {
      type: Object,
      default: () => ({}),
    },
    value: {},
  },
  data() {
    return {
      //not really using
      rules,
      placeholder: 'Filter',
    };
  },
  methods: {
    setInput(val) {
      this.$emit('input', val);
    },
    updateSearch(val) {
      this.$emit('updateSearch', val);
    },
  },
  computed: {
    getOptions() {
      return [];
    },
    formattedValue() {
      return this.value;
    },
    searchLoading() {
      return this?.loading || false;
    },
  },
};
</script>
